import React from "react";
import { Button as AntdButton, Form } from "antd";
import { Styles } from "../Config/ThemeConfig";

export function Button({
  type,
  btype = "button",
  text,
  loading = false,
  icon,
  classname,
  onclick,
  disabled = false,
}) {
  return (
    <Form.Item className={`w_100_p m_0 ${classname}`}>
      <AntdButton
        type={type}
        htmlType={btype}
        loading={loading}
        onClick={onclick}
        size={Styles.input_size}
        disabled={disabled}
      >
        {icon && <>{icon} </>} {text}
      </AntdButton>
    </Form.Item>
  );
}
